<template>
    <div class="affair-change"></div>
</template>
<script>
    export default {
        name:"affair-change"
    }
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/components/main/affairChange.vue